import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@react-pdf/renderer'

import {
  tresholdForDisplay,
  bloodPressureTresholdForDisplay,
} from '@util/tresholdUtil'
import colors from '@settings/styleSettings'
import Text from './Text'

export const TresholdDisplay = ({
  syst, diast, value, type
}) => (
  <View style={{ color: colors.strongGray }}>
    {type === 'bloodPressure'
      ? bloodPressureTresholdForDisplay(syst, diast, Text)
      : tresholdForDisplay(type, value, Text)}
  </View>
)

TresholdDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  syst: PropTypes.number.isRequired,
  diast: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
}
